
<template>

<v-btn icon :to="{name: 'mail'}">
  <v-badge color="red"
        :content="messages"
        :value="messages"
  >

    <v-icon color="white">mail</v-icon>
  </v-badge>
</v-btn>
</template>

<script>
  export default {
    name: 'messages',
    data () {
      return {}
    },
    methods: {},
    watch: {
      messages: {
        handler: function (newValue, oldValue) {
          if (newValue && (newValue > oldValue)){
            this.$store.commit('playSound', 'mail');
          }
        }
      }
    },
    computed: {
      messages: {
        cache: false,
        get () {
          return this.$store.getters.messages.length
        }
      },
    },
    created () {},
    beforeDestroy () {}
  }
</script>


<style lang="scss">
.logo-home {
  opacity: 0.1;
  margin: 0 auto;
}
</style>
